import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { fetchRequestInterceptors } from "@faire/help-center/initialize/requestInterceptors";
import { responseInterceptors } from "@faire/help-center/initialize/responseInterceptors";
import { addEventInterceptor, addRequestInterceptor, addResponseInterceptor, setRequestHandler } from "@faire/web-api";
import { datadogInterceptor } from "@faire/web/common/events/interceptors/datadogInterceptor";
import { facebookInterceptor } from "@faire/web/common/events/interceptors/facebookInterceptor";
import { hotjarInterceptor } from "@faire/web/common/events/interceptors/hotjarInterceptor";
import { requestHandler as fetchRequestHandler } from "@faire/web/common/requests/handlers/fetch";
export var init = function init() {
  responseInterceptors.forEach(addResponseInterceptor);
  fetchRequestInterceptors.forEach(addRequestInterceptor);
  setRequestHandler(fetchRequestHandler);
  addEventInterceptor(datadogInterceptor);
  addEventInterceptor(facebookInterceptor);
  addEventInterceptor(hotjarInterceptor);
};